import React, {useEffect} from 'react';
import {withStyles} from '@material-ui/core/styles';
import h from 'react-hyperscript';
import {Dialog, Tabs, Tab, Tooltip} from '@material-ui/core';
import MuiTooltip from '@material-ui/core/Tooltip';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MemberList from 'Components/MemberList/MemberList';
import ShareReportLink from 'Components/ShareReportLink/ShareReportLink';
import './ManageMembers.scss';

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '0px',
    margin: '0px',
  },
}))(MuiDialogContent);

const BlueTooltip = withStyles({
  tooltip: {
    'backgroundColor': '#1a73e8',
    'pointer-events': 'all',
    'border-radius': '6px',
    'padding': '16px',
  },
})(MuiTooltip);


export default function ManageMembers(props) {
  const [open, setOpen] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(1);
  const [tooltipOpen, setTooltipOpen] = React.useState(true);

  useEffect(() => {
    if (props.externalOpen === true) {
      handleClickOpen();
    }
  }, [props.externalOpen]);

  const changeTabs = (event, newTabValue) => {
    setTabValue(newTabValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
    setTooltipOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    if (typeof props.handleClose === 'function') {
      props.handleClose();
    }
  };

  return (
    h(React.Fragment, [
      h(Tooltip, {title: 'Manage report access'}, [
        h('a', {
          className:
            `button--inline button--cal manage-members__button ${props.class}`,
          onClick: handleClickOpen,
        },
        [
          h('span', {
            className: 'material-icons',
          }, 'people'),
        ]),
      ]),
      h(Dialog, {
        'onClose': handleClose,
        'key': 'manage-members-modal',
        'aria-labelledby': 'customized-dialog-title',
        'open': open,
      }, [
        h(MuiDialogTitle, {
          'className': 'manage-members__title',
        }, [

          h(BlueTooltip, {
            placement: 'right-start',
            arrow: 'true',
            title: h(React.Fragment, [
              h('p', {className: 'share-modal__tooltip-text'},
                  'You can grant and revoke view-only access to ' +
                  'anyone with a valid Google account (Google Workspace ' +
                  'for Education or Gmail). You can add multiple email ' +
                  'addresses at a time by using commas as the separator. ' +
                  'Please make sure you type each email address correctly. ' +
                  'Note: adding an email here will not notify the person of ' +
                  'their access. You must directly share the link found on ' +
                  'the next screen with each user you add. Anyone you grant ' +
                  'access to will be able to see all of your transformation ' +
                  'reports until you revoke access, but they cannot grant ' +
                  'access to others. You can revoke access at any time. '),
              h('a', {
                className: 'share-modal__tooltip-close',
                onClick: () => setTooltipOpen(false),
              }, 'Got it'),
            ]),
            open: tooltipOpen,
          }, [
            h('span', {
              className: 'manage-members__icon material-icons',
            }, 'people'),
          ]),
          h('span', {
            onClick: () => setTooltipOpen(true),
            style: {
              cursor: 'pointer',
            },
          }, 'Manage Report Access'),
          h(IconButton, {
            label: 'close',
            className: 'close-button',
            id: 'manage-members__close',
            onClick: handleClose,
          }, [
            h(CloseIcon, [
            ])]),
        ]),
        h('div', {className: 'manage-members__nav'},
            [
              h(Tabs, {
                'value': tabValue,
                'onChange': changeTabs,
                'indicatorColor': 'primary',
                'textColor': 'primary',
                'aria-label': 'Manage viewers nav',
              }, [
                h(Tab, {
                  className: 'manage-members__tab',
                  value: 1,
                  label: h(React.Fragment, [h('p', [
                    h('span', {className: 'manage-members__tab-icon'}, '1'),
                    'Manage viewers',
                  ]),
                  ]),
                }),
                h(Tab, {
                  className: 'manage-members__tab',
                  value: 0,
                  label: h(React.Fragment, [h('p', [
                    h('span', {className: 'manage-members__tab-icon'}, '2'),
                    'Share link',
                  ]),
                  ]),
                }),
              ]),
            ]
        ),
        h(DialogContent, {
          dividers: true,
        }, [
          h(
              'div',
              {
                className: 'manage-members__container',
              },
              [
                tabValue ? h(MemberList, {
                  members: props.members,
                  setMembers: props.setMembers,
                  googleUser: props.googleUser,
                  userStatus: props.userStatus,
                  csrf: props.csrf,
                  idToken: props.idToken,
                  districtId: props.districtId,
                  callback: () => setTabValue(0),
                }) : h(ShareReportLink),
              ]
          ),
        ]),

      ]),
    ])

  );
}
